export const ROOM_CODE_LENGTH = 6;
export const MAX_SEATS = 4;
export const MIN_SEATS = 2;
export const MAX_NAME_LENGTH = 20;
export const MAX_CHAT_LENGTH = 200;
/* Bounded because these strings are relayed to another player untouched. A real
   audio-only offer is a few kilobytes; anything past this is not a session. */
export const MAX_SDP_LENGTH = 16_384;
export const MAX_CANDIDATE_LENGTH = 512;
export const MAX_SDP_MID_LENGTH = 16;
/* Bounds on a match goal, enforced at the socket boundary rather than only in the
   lobby UI: a client can send whatever it likes. A one-round match is a single
   game, which is why the floor on rounds is 1 and not 2. */
export const MIN_POINTS_TARGET = 50;
export const MAX_POINTS_TARGET = 2000;
export const MIN_ROUNDS = 1;
export const MAX_ROUNDS = 20;
/** What a host gets by default: the official target. */
export const DEFAULT_MATCH_GOAL = { kind: 'points', target: 500 };
/* Below three seconds nobody can read their hand; above two minutes it has
   stopped being a limit. Enforced at the socket boundary, not only in the lobby. */
export const MIN_TURN_SECONDS = 3;
export const MAX_TURN_SECONDS = 120;
export const DEFAULT_TURN_SECONDS = 15;
/**
 * Fixed rather than exposed. It exists so a fast match does not stall waiting for
 * the host to click Next round, and a second dial for it would be a setting nobody
 * has an opinion about.
 */
export const BETWEEN_ROUNDS_SECONDS = 5;
/**
 * How long a seat has to say UNO after playing down to one card, on a table without
 * call-outs.
 *
 * Fixed for the same reason: it is a reflex window, not a house rule, and the lobby
 * already carries four rules and two dials. Three seconds is long enough to reach a
 * button that is already on screen and short enough that the table does not wait.
 *
 * In the protocol package because both ends may want it, but nothing on the wire carries
 * a deadline for it yet: the exposed player sees the banner and a live UNO button, not a
 * countdown. The server remains the only thing that charges anything when it runs out.
 */
export const UNO_GRACE_SECONDS = 3;
/* `TableRules` is declared in @uno/engine rather than here beside MatchPace, and that
   split is the point: a clock is a house setting the engine never sees, while those
   flags change what the rules are and the reducer has to read them. The protocol
   re-exports the type and carries it on the wire - on `LobbyView` and on `PlayerView`
   both - but it does not own it, so there is exactly one definition of what a rule is.

   On both views, because a rule read once before the deal is not one anybody remembers
   twenty minutes later: a manual UNO penalty got reported as a missing one, and the game
   was right. And on the player view rather than sent once and cached client-side, because
   a reload mid-game receives a PlayerView and no lobby at all. */
/** Alphabet without ambiguous characters: no O/0, no I/1. */
export const ROOM_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
//# sourceMappingURL=views.js.map